import BaseConcurrencyRequest from "@/models/server/requests/BaseConcurrencyRequest";

export default class PauseWorkOrderRequest extends BaseConcurrencyRequest {

    public workOrderId: string = "";

    public pauseStartDate: Date | null = null;

    public pauseEndDate: Date | null = null;
}